export default "/images/ic-template.svg?38ee395e91f4283e758ad1e4d7dbaf09";